import { render } from "./About.vue?vue&type=template&id=2ab2b380"
const script = {}
script.render = render

export default script